import "../css/Faqs.css";

const faqs = [
  {
    q: "Do I need an appointment?",
    a: "Yes. We operate by appointment only to ensure every guest receives our full attention.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking at least one to two weeks ahead, especially for weekends.",
  },
  {
    q: "Do you offer consultations?",
    a: "All services begin with a personalized consultation tailored to your needs.",
  },
  {
    q: "What products do you use?",
    a: "We use premium, professional-grade products selected for performance and care.",
  },
  {
    q: "What is your cancellation policy?",
    a: "We kindly ask for 24 hours’ notice for cancellations or rescheduling.",
  },
];

const Faqs = () => {
  return (
    <main className="salon-faqs">

      {/* HERO */}
      <section className="faqs-hero">
        <h1>FAQs</h1>
        <p>
          Thoughtful answers<br />
          to common questions.
        </p>
      </section>

      {/* LIST */}
      <section className="faqs-list">
        {faqs.map((item, index) => (
          <div className="faq-item" key={index}>
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </section>

      {/* CLOSING */}
      <section className="faqs-closing">
        <p>
          If you need more clarity,<br />
          we’re always happy to help.
        </p>
      </section>

    </main>
  );
};

export default Faqs;
